import styled from 'react-emotion'
import { Link } from 'gatsby'

const Wrapper = styled(Link)`
	display: flex;
	flex-direction: column;
	margin: 1rem 0;
	color: #000;
	width: 100%;
`

export default Wrapper;
